import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';
import RevisionPredefinedDataPicker from 'components/inputs/revision-predefined-data/RevisionPredefinedDataPicker';
import {
  RevisionPredefinedDataSelection,
  RevisionPredefinedDataSource,
} from 'components/inputs/revision-predefined-data/types';
import { useRevisionPredefinedDataCatalog } from 'components/inputs/revision-predefined-data/useRevisionPredefinedDataCatalog';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { IFormInputSpecPredefinedSelect } from 'pages/revisions-module/template-editor/editors/form/types';

interface PredefinedDataSelectValue extends RevisionPredefinedDataSelection {
  primary: string;
  source?: RevisionPredefinedDataSource;
}

/**
 * Computes the display value used for revision indexing.
 */
function getPrimaryValue(value: RevisionPredefinedDataSelection, useDescription?: boolean) {
  if (useDescription && value.description) {
    return value.description;
  }

  return value.name;
}

/**
 * Predefined data select input for the revision form.
 */
export default function RevisionFieldPredefinedSelect({
  spec: { label, dataTypeId, useDescription, required },
  name,
}: RevisionFieldProps<IFormInputSpecPredefinedSelect>) {
  const { form, revision } = useFillOutRevisionDataProvider();
  const { value, onChange } = form.getInputProps(name);

  const catalog = useRevisionPredefinedDataCatalog({
    deviceTypeId: revision.deviceType.deviceTypeId,
    predefinedDataType: Number(dataTypeId),
    revisionId: revision.revisionId,
  });

  return (
    <RevisionPredefinedDataPicker
      size="lg"
      searchable
      name={name}
      label={label}
      placeholder="Vyberte"
      required={required}
      clearable={!required}
      value={value as PredefinedDataSelectValue | undefined}
      loading={catalog.loading}
      options={catalog.options}
      deviceTypeName={revision.deviceType.deviceTypeName}
      predefinedDataTypeId={Number(dataTypeId)}
      predefinedDataTypeName={catalog.predefinedDataTypeName}
      onCatalogOptionCreate={catalog.upsertCatalogOption}
      onChange={(nextValue) =>
        onChange(
          nextValue
            ? {
                ...nextValue,
                primary: getPrimaryValue(nextValue, useDescription),
              }
            : undefined
        )
      }
    />
  );
}
